import React from 'react';

const FAQ = () => {
    return (
        <>
        <div className="body d-flex py-3">
          <div className="container-xxl">
            <div className="row align-items-center">
              <div className="border-0 mb-4">
                <div className="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                  <h3 className="fw-bold mb-0">FAQs</h3>
                </div>
              </div>
            </div>
            <div className="row align-item-center">
              <div className="col-md-12">
                <div className="card mb-3">
                  <div className="card-header py-3 bg-transparent border-bottom-0">
                    <h6 className="mb-0 fw-bold">Frequently Asked Questions</h6>
                  </div>
                  <div className="card-body">
                    <h6 className="mb-0 fw-bold">1. What is DCIWallet.com?</h6>
                    <p>DCIWallet.com is a cryptocurrency investment platform that allows individuals to pool their funds and invest in large-scale projects, including government initiatives and scientific research, as well as opportunities in the crypto market. </p>
                    
                    <h6 className="mb-0 fw-bold">2. How does DCIWallet.com work?</h6>
                    <p>Users create an account, choose an investment plan, deposit their cryptocurrency, and our team invests the pooled funds in high-potential projects aimed at generating significant returns.
                    </p>

                    <h6 className="mb-0 fw-bold">3. What types of investments can I make through DCIWallet.com?</h6>
                    <p>You can invest in a variety of plans that encompass government projects, scientific advancements, land acquisitions, and diverse options within the cryptocurrency market.</p>
                    
                    <h6 className="mb-0 fw-bold">4. What investment plans are available?</h6>
                    <p>DCIWallet.com offers multiple investment plans tailored to no risk profiles and expected returns. These plans accommodate both short term and long-term investment strategies.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default FAQ;
